import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { privateLoginStatus } from '@/state/privateAuth';
import routes from '@/components/private/routes';

export type AuthenticatedRouteProps = PropsWithChildren;

/**
 * Guards its children, redirecting to the login page if the current user is logged out.
 */
const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(privateLoginStatus);

  if (loginStatus === 'LOGGED_OUT') {
    return <Navigate to={routes.login} replace />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
